
import { defineComponent, PropType } from 'vue'
import { Product , TransactionType } from '../../../types'
import ProductSelect from '../../form/productindex/ProductSelect.vue'
import {useRoute} from 'vue-router'
import {computed} from 'vue'

interface RowPayload {
  values: Record<string, any>[];
}

export default defineComponent({
  name: 'ProductLineRow',
  components: {
    ProductSelect
  },
  props: {
    products: {
      type: Array as PropType<Product[]>
    },
    rowId: {
      type: Number
    },
    values: {
      type: Object as PropType<Record<string, any>>
    },
    isRemovable: {
      type: Boolean
    },
    apiErrors: {
      type: Object as PropType<Record<string, any>>
    }
  },
  emits:['rowRemove','rowUpdate'],
  data () {
    return {
      item: {}
    }
  },
  created(){
   // console.log(this.rowId);
  },
  methods: {
    removeRow () {
      this.$emit('rowRemove', this.rowId)
    },
    updateRow (event: Event) {
      const target = event.target as HTMLInputElement
      let value = undefined
      switch(target.type) {
        case 'number':
          value = target.value
          break
        case 'select-one':
          value = +target.value
          break
        case 'checkbox':
        case 'radio':
          value = target.checked
          break
        default:
          value = target.value
          break
      }
      const payloadValues = [{ name: target.name, value}]
      if (target.name === 'price_ratio') {
        payloadValues.push({ name: 'transaction_type', value: this.isBuyOrSell(parseFloat(target.value)) })
      }
      this.$emit('rowUpdate', { row: this.rowId, values: payloadValues })
    },
    updateRowProduct (value: RowPayload) {
      this.$emit('rowUpdate', { row: this.rowId, values: [ value ] })
    },
    initValue (event: Event) {
      const target = event.target as HTMLInputElement
      if (target.value === '') {
        target.value = '0'
        const payloadValues = [{ name: target.name, value: target.value}]
        if (target.name === 'price_ratio') {
          payloadValues.push({ name: 'transaction_type', value: this.isBuyOrSell(parseFloat(target.value)) })
        }
        this.$emit('rowUpdate', { row: this.rowId, values: payloadValues })
      }
    },
    isBuyOrSell (value: number): TransactionType {
      if (value <= 0) {
        return TransactionType.SELL
      } else {
        return TransactionType.BUY
      }
    }
  },

  mounted () {
    const route=useRoute();

    const path = computed(() =>route.name)
    if (path.value === 'StrategiesCreate') {
      if ( this.rowId === 0 ) {
        this.$emit( 'rowUpdate' , { row : this.rowId , values : [ { name : 'is_key_contract' , value : true } ] } )
      }
    }
  },
})

function currentLocation(currentLocation: any) {
    throw new Error('Function not implemented.');
}
